<div class = "main-container">
  <nav class="navbar navbar-light navbar-expand-md navigation-clean" style="height: 70px;" (keydown.escape)="closeMobileMenu()">
    <div class="container">
      <div class="navbar-brand"style="width: 200px;height: 40px;">
        <div class="def_image" *ngIf="isLoggedIn()">
          <img src="../assets/img/Logo.svg" alt="Lights" style="width:20%" >
          <p class="col-md-4 navbar-brand"style="font-weight: bold; font-family: 'Nunito Sans', sans-serif; font-size: 20px; color: #15274d;">Booking Dexter</p>
        </div>
        <div class="def_image" *ngIf="!isLoggedIn()">
          <a  href="">
            <img src="../assets/img/BookingDexter_Compressed.svg" alt="Lights" style="width: 350px;height: 45px;" >

          </a>
        </div>
      </div>

      <button type="button" class="navbar-toggler brand-menu-toggle" (click)="mobileMenuOpen = !mobileMenuOpen" [attr.aria-expanded]="mobileMenuOpen" aria-controls="ham-menu" [attr.aria-label]="mobileMenuOpen ? 'Close navigation' : 'Open navigation'">
        <span class="sr-only">Toggle navigation</span>
        <mat-icon aria-hidden="true">{{ mobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
      </button>
      <div class="collapse navbar-collapse dropdown-content" id="ham-menu" [class.show]="mobileMenuOpen">
        <ul class="nav navbar-nav ml-auto">
          <li *ngIf = "!(roleId == 1 || roleId == 2)" class="nav-item" [routerLinkActive]="['active']" role="presentation" style="height: 40px;">
            <a routerLink="/businesses" class="nav-link blueText book-now-nav-link" (click)="collapseMenu()"><mat-icon aria-hidden="true">add_circle_outline</mat-icon><span>Book-Now</span></a>
          </li>

          <li *ngIf="isLoggedIn() && (roleId == 2 || roleId == 0)" class="nav-item hidden-mobile"  [routerLinkActive]="['active']" role="presentation" style="cursor: pointer;">
            <a routerLink="/landing-page/dashboard" class="nav-link blueText" (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">admin_panel_settings</mat-icon><span>Admin</span></a>
          </li>
          <li *ngIf="logInStatus && (roleId == 1)" class="nav-item"  [routerLinkActive]="['active']" role="presentation" style="height: 40px; cursor: pointer;">
            <a routerLink="/tenants-grid" class="nav-link blueText"  (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">storefront</mat-icon><span>Tenants</span></a>
          </li>
          <li *ngIf="logInStatus && (roleId == 1)" class="nav-item"  [routerLinkActive]="['active']" role="presentation" style="height: 40px; cursor: pointer;">
            <a routerLink="/users" class="nav-link blueText"  (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">people</mat-icon><span>Users</span></a>
          </li>
          <li *ngIf="logInStatus && (roleId == 1)" class="nav-item"  [routerLinkActive]="['active']" role="presentation" style="height: 40px; cursor: pointer;">
            <a routerLink="/payment" class="nav-link blueText"  (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">payments</mat-icon><span>Payment</span></a>
          </li>
          <li *ngIf="isLoggedIn() && (roleId == 3)" class="nav-item hidden-mobile"  [routerLinkActive]="['active']" role="presentation" style="height: 40px; cursor: pointer;">
            <a routerLink="/landing-page/transactions" class="nav-link blueText"  (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">event_note</mat-icon><span>My Bookings</span></a>
          </li>
          <li *ngIf="logInStatus  && (roleId == 1 || roleId == 2)" class="nav-item hidden-DesktopOrTablet" routerLinkActive="active" role="presentation">
            <a routerLink="/landing-page/dashboard" class="nav-link blueText" (click)="collapseMenu()"><mat-icon aria-hidden="true">dashboard</mat-icon><span>Dashboard</span></a>
          </li>
          <li *ngIf="logInStatus  && (roleId == 1 || roleId == 2)" class="nav-item hidden-DesktopOrTablet" routerLinkActive="active" role="presentation">
            <a routerLink="/landing-page/admin-bookings" class="nav-link blueText" (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">event_note</mat-icon><span>Bookings</span></a>
          </li>
          <li *ngIf="logInStatus && (roleId == 1 || roleId == 2)" class="nav-item hidden-DesktopOrTablet" routerLinkActive="active" role="presentation">
            <a routerLink="/landing-page/transactions" class="nav-link blueText" (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">receipt_long</mat-icon><span>Transactions</span></a>
          </li>
          <li *ngIf="logInStatus && (roleId == 1 || roleId == 2)" class="nav-item hidden-DesktopOrTablet" routerLinkActive="active" role="presentation">
            <a routerLink="/landing-page/reports" class="nav-link blueText" (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">assessment</mat-icon><span>Reports</span></a>
          </li>
          <li *ngIf="logInStatus && (roleId == 3)" class="nav-item hidden-DesktopOrTablet" routerLinkActive="active" role="presentation">
            <a routerLink="/landing-page/transactions" class="nav-link blueText" (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">event_note</mat-icon><span>My Bookings</span></a>
          </li>
          <li *ngIf="logInStatus  && (roleId == 1 || roleId == 2)" class="nav-item hidden-DesktopOrTablet" routerLinkActive="active" role="presentation">
            <a routerLink="/landing-page/company-profile" class="nav-link blueText" (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">business</mat-icon><span>Company Profile</span></a>
          </li>
          <li *ngIf="logInStatus && (roleId == 1 || roleId == 2)" class="nav-item hidden-DesktopOrTablet" routerLinkActive="active" role="presentation">
            <a routerLink="/landing-page/products" class="nav-link blueText" (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">category</mat-icon><span>Services</span></a>
          </li>

          <li *ngIf="logInStatus && (roleId == 1 || roleId == 2)" class="nav-item hidden-DesktopOrTablet" routerLinkActive="active" role="presentation">
            <a routerLink="/landing-page/venues" class="nav-link blueText" (click)="collapseMenu()" style="cursor: pointer;"><mat-icon aria-hidden="true">place</mat-icon><span>Venues</span></a>
          </li>
          <li *ngIf="!logInStatus" class="nav-item" role="presentation" style="height: 40px; cursor: pointer;">
            <div class="row" >
              <a class="nav-link blueText" (click)="onClickLogin(); collapseMenu()" style="padding-bottom: 2px;"><mat-icon aria-hidden="true">login</mat-icon><span>Login / SignUp</span></a>
            </div>
          </li>
          <li *ngIf="!logInStatus && !isNativeApp" class="hidden-mobile">
            <asl-google-signin-button type="icon"></asl-google-signin-button>
          </li>

          <li *ngIf="!logInStatus && !isNativeApp" class="hidden-DesktopOrTablet" style="padding-left: 5px; height: 42px;">
            <asl-google-signin-button type="standard"></asl-google-signin-button>
          </li>

          <li *ngIf="logInStatus" class="nav-item dropdown" ngbDropdown #accountDropdown="ngbDropdown" placement="bottom-end" style="height: 40px;">
              <button type="button" class="nav-link account-toggle blueText" id="navbarDropdownMenuLink" ngbDropdownToggle aria-label="Account menu"><mat-icon aria-hidden="true">account_circle</mat-icon><span>{{getLoginDisplayText()}}</span></button>
              <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="navbarDropdownMenuLink">
                <button type="button" class="dropdown-item blueText" ngbDropdownItem (click)="clickedProfile(); collapseMenu()"><mat-icon aria-hidden="true">person_outline</mat-icon><span>Profile</span></button>
                <button type="button" class="dropdown-item blueText" ngbDropdownItem (click)="clickedLogout(); collapseMenu()"><mat-icon aria-hidden="true">logout</mat-icon><span>Logout</span></button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>

</div>

<ng-template #content let-modal>
  <div class="modal-body">
    <div class="login-main-card" [class.auth-centered]="showSignInForm || showSignUpForm || showForgotPasswordForm || showResetPasswordForm">
      <button class="close-button"
              type="button"
              (click)="onCancelLogin()">
        X
      </button>
      <div class="row justify-content-center">
        <div class="col-auto" style="padding-top: 20px; ">
          <img class = "center" src="../assets/img/Logo.svg" alt="Lights" style="width: 45px;height: 45px;">
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div *ngIf="showSignUpForm" class="auth-page-container">
            <form [formGroup]="signUpFormGroup" class="auth-form-container text-center">
              <div class="row">
                <div class="col" style="margin-top: 20px;">
                  <h1 style="font-size: 30px;color: #14274e; font-family: 'Nunito-B';">
                    Join Our Family
                  </h1>
                  <p style="font-size: 13px;color: #7c7575;height : 18px">
                    And be part of this amazing community
                  </p>
                </div>
              </div>
              <div class="form-group">
                <div style="margin-top: 10px;">
                  <label for="first-name" style="float: left;font-size: 11px; color: #7c7575; font-weight: bold;">
                    FIRST NAME *
                  </label>
                  <input type="text" id="first-name" class="form-control" formControlName="firstNameFormControl" placeholder="First Name"
                         class="form-control auth-input" />
                  <div *ngIf="signUpFormControls.firstNameFormControl.hasError('required') && signUpFormControls.firstNameFormControl.touched" style="color: red; font-size: 14px;">
                    First Name is required.
                  </div>
                  <div *ngIf="signUpFormControls.firstNameFormControl.hasError('pattern') && signUpFormControls.firstNameFormControl.touched" style="color: red; font-size: 14px;">
                    First Name must contain letters only (A–Z).
                  </div>
                </div>
                <div style="margin-top: 5px;">
                  <label for="last-name" style="float: left; font-size: 11px; color: #7c7575; font-weight: bold;">
                    LAST NAME *
                  </label>
                  <input type="text" id="last-name" class="form-control" formControlName="lastNameFormControl" placeholder="Last Name"
                         class="form-control auth-input" />
                  <div *ngIf="signUpFormControls.lastNameFormControl.hasError('required') && signUpFormControls.lastNameFormControl.touched" style="color: red; font-size: 14px;">
                    Last Name is required.
                  </div>
                  <div *ngIf="signUpFormControls.lastNameFormControl.hasError('pattern') && signUpFormControls.lastNameFormControl.touched" style="color: red; font-size: 14px;">
                    Last Name must contain letters only (A–Z).
                  </div>
                </div>

                <div style="margin-top: 5px;">
                  <label for="email-address" style="float: left;font-size: 11px; color: #7c7575; font-weight: bold;">
                    EMAIL ADDRESS *
                  </label>
                  <input type="text" id="email-address" class="form-control" formControlName="emailFormControl" placeholder="Email"
                         class="form-control auth-input" />
                  <div *ngIf="signUpFormControls.emailFormControl.hasError('required') && signUpFormControls.emailFormControl.touched" style="color: red; font-size: 14px;">
                    Email is required.
                  </div>
                  <div *ngIf="signUpFormControls.emailFormControl.hasError('email') && signUpFormControls.emailFormControl.touched" style="color: red; font-size: 14px;">
                    Invalid email address.
                  </div>
                </div>
                <div style="margin-top: 5px;">
                  <label for="contact-number" style="float:left; font-size: 11px; color: #7c7575; font-weight: bold;">
                    CONTACT NUMBER *
                  </label>
                  <!--<div>
                    <label style="line-height: 41px; z-index: 99; position: absolute; margin-left: 10px;" for="contact-number">+91 - </label>
                  </div>-->
                  <input type="text" id="contact-number" class="form-control" formControlName="phoneNoFormControl" placeholder="Phone Number" maxlength="10"
                         class="form-control auth-input" />
                  <div *ngIf="signUpFormControls.phoneNoFormControl.hasError('required') && signUpFormControls.phoneNoFormControl.touched" style="color: red; font-size: 14px;">
                    Phone Number is required.
                  </div>
                  <div *ngIf="signUpFormControls.phoneNoFormControl.hasError('pattern') && signUpFormControls.phoneNoFormControl.touched" style="color: red; font-size: 14px;">
                    Invalid phone number. Must be 10 digits.
                  </div>
                </div>
                <div class="form-check" style="padding-top: 15px;">
                  <input type="checkbox" id="checkbox-login" class="form-check-input" formControlName="checkboxFormControl" style="width: 16px; height: 16px; margin-top: 7px;" />
                  <label class="form-check-label" for="checkbox-login" style="font-size: 14px; color: #7c7575; font-family: 'Nunito-B';">
                    I have read and agreed to * <br>
                    <a routerLink="/terms">Terms &amp; Conditions</a> and
                    <a routerLink="/privacy-policy">Privacy Policy</a>.
                  </label>
                  <div *ngIf="signUpFormControls.checkboxFormControl.hasError('required') && signUpFormControls.checkboxFormControl.touched" style="color: red; font-size: 14px;">
                    You must agree to the terms and conditions.
                  </div>
                </div>

                <div *ngIf="userExistsError" style="margin-top: 10px; color: red;font-size: 14px;">
                  User Email Address or Phone Number already exists.
                </div>
                <div style="margin-top: 20px;">
                  <button class="btn btn-primary signin-btn" type="button" [disabled]="!signUpFormGroup.valid" (click)="onGetStartedClicked()">
                    Get Started
                  </button>
                </div>
              </div>
              <div class="auth-center" style="margin-top:30px;">
                <p style="font-size: 14px; font-family: 'Nunito-B';">
                  Already Have an Account?  <a (click)="onShowSignInFormClicked()" style="cursor: pointer; color: #14274E; font-size: 20px; font-family: 'Nunito-B';"> Sign In</a>
                </p>
              </div>
            </form>
          </div>


          <div *ngIf="showPhoneNumberForm">
            <form [formGroup]="phoneNumberFormGroup" class="auth-form-container text-center">
              <div class="form-group auth-form-container">
                <div class="row auth-title">
                  <div style="margin-top:20px;">
                    <h1 style="font-size:30px;color:#14274e;font-family:'Nunito-B';margin-bottom:0;">
                      Add Phone Number
                    </h1>
                  </div>
                </div>
                <div style="margin-top: 20px;">
                  <label style="float: left; font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="post-login-phone">
                    PHONE NUMBER
                  </label>
                  <input type="text" id="post-login-phone" class="form-control auth-input"
                         formControlName="phoneNumberFormControl"
                         placeholder="Phone Number"
                         maxlength="10"
                         (input)="clearPhoneUpdateError()"
                         style="height: 40px; padding-right: 5px;" />
                  <div *ngIf="phoneNumberFormControls.phoneNumberFormControl.hasError('required') && phoneNumberFormControls.phoneNumberFormControl.touched" style="color: red;font-size: 14px;">
                    Phone Number is required.
                  </div>
                  <div *ngIf="phoneNumberFormControls.phoneNumberFormControl.hasError('pattern') && phoneNumberFormControls.phoneNumberFormControl.touched" style="color: red;font-size: 14px;">
                    Please enter a valid 10-digit mobile phone number.
                  </div>
                </div>

                <div *ngIf="phoneUpdateError" style="color: red;font-size: 14px; margin-top: 20px;">
                  {{phoneUpdateError}}
                </div>

                <div style="margin-top: 20px;">
                  <button class="btn btn-primary signin-btn" type="button" (click)="onSubmitPhoneNumber()">
                    Continue
                  </button>
                </div>
              </div>
            </form>
          </div>


          <div *ngIf="showSignInForm">
            <form [formGroup]="signInFormGroup" class="auth-form-container text-center">
              <div class="form-group auth-form-container">
                <div class="row auth-title">
                  <div style="margin-top:20px;">
                    <h1 style="font-size:30px;color:#14274e;font-family:'Nunito-B';margin-bottom:0;">
                      Sign In
                    </h1>
                  </div>
                </div>
                <div style="margin-top: 20px;">
                  <label style="float: left; font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="email-address">
                    EMAIL ADDRESS
                  </label>
                  <!-- this is to avoid auto focus on first input element -->
                  <input type="text" style="display:none" />
                  <input type="text" id="email-address" class="form-control auth-input" formControlName="emailFormControl" placeholder="Email"
                         style=" height: 40px; padding-right: 5px;" />
                  <div *ngIf="signInFormControls.emailFormControl.hasError('required') && signInFormControls.emailFormControl.touched" style="color: red;font-size: 14px;">
                    Email is required.
                  </div>
                </div>
                <div style="margin-top: 15px;">
                  <label style="float: left; font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="password">
                    PASSWORD
                  </label>
                  <a (click)="onShowForgotPasswordFormClicked()" style="float: right; cursor: pointer; color: #14274E; font-size: 13px; font-family: 'Nunito-B';padding-right: 15px;"> Forgot Password?</a>

                  <div class="password-input-wrapper">
                    <input [type]="showPassword ? 'text' : 'password'" id="password" class="form-control auth-input" formControlName="passwordFormControl" placeholder="Password"
                           style="height: 40px;padding-right: 42px; " (input)="onPasswordInput()"/>
                    <button type="button" class="password-toggle-btn" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [title]="showPassword ? 'Hide password' : 'Show password'" (click)="togglePasswordVisibility()">
                      <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                    </button>
                  </div>
                  <div *ngIf="signInFormControls.passwordFormControl.hasError('required') && signInFormControls.passwordFormControl.touched" style="color: red;font-size: 14px;">
                    Password is required.
                  </div>
                </div>

                <div *ngIf="showSignInError" style="color: red;font-size: 14px; margin-top: 20px;">
                  {{signInError}}
                </div>

                <div class="auth-center" style="margin-top: 20px;">
                  <button class="btn btn-primary signin-btn" type="button" (click)="onClickedSignIn()">
                    Sign In
                  </button>
                </div>
                <div class="auth-center" style="padding-top:15px;">
                  <p style="color: #14274E; font-size: 14px; font-family: 'Nunito-B';">
                    OR
                  </p>
                </div>
                <div *ngIf="!isNativeApp" class="auth-center google-btn-wrapper" style="height: 44px;">
                  <asl-google-signin-button
                    type="standard"
                    size="medium"
                    width="200"
                  >
                  </asl-google-signin-button>
                </div>
                <div *ngIf="isNativeApp" class="auth-center google-btn-wrapper" style="height: 44px;">
                  <button type="button" class="google-native-signin-btn" (click)="nativeGoogleSignIn()">
                    <span class="google-native-signin-icon">G</span>
                    <span>Sign in with Google</span>
                  </button>
                </div>
                <div *ngIf="nativeGoogleSignInError" style="color: red;font-size: 14px; margin-top: 12px;">
                  {{nativeGoogleSignInError}}
                </div>
                <div class="center" style="margin-top: 30px;">
                  <p class="auth-footer"
                     style="font-size:14px;font-family:'Nunito-B';">

                    <span>Do not Have an Account?</span>

                    <a (click)="onShowSignUpFormClicked()"
                       style="
                                          cursor:pointer;
                                          color:#14274E;
                                          font-size:20px;
                                          font-family:'Nunito-B';">
                      Sign Up
                    </a>
                  </p>
                </div>
              </div>
            </form>
          </div>

          <div *ngIf="showForgotPasswordForm">
            <form [formGroup]="forgotPasswordFormGroup">
              <div class="form-group auth-form-container">
                <div class="row">
                  <div class="col center" style="margin-top: 20px;">
                    <h1 class="text-center" style="font-size: 30px; padding: 0px;color: #14274e; font-family: 'Nunito-B';">
                      Forgot Password
                    </h1>
                  </div>
                </div>
                <div *ngIf="isEmailFilled()" style="margin-top: 20px;">
                  <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="email-address">
                    EMAIL ADDRESS
                  </label>
                  <input type="text" style="display:none" />
                  <input disabled type="text" id="email-address" class="form-control" formControlName="emailFormControl"
                         class="form-control auth-input" />
                </div>
                <div *ngIf="!isEmailFilled()" style="margin-top: 20px;">
                  <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="email-address">
                    EMAIL ADDRESS
                  </label>
                  <input type="text" style="display:none" />
                  <input type="text" id="email-address" class="form-control" formControlName="emailFormControl" placeholder="Email"
                         class="form-control auth-input" />
                  <div *ngIf="forgotPasswordFormControls.emailFormControl.hasError('required') && forgotPasswordFormControls.emailFormControl.touched" style="color: red;font-size: 14px;">
                    Email is required.
                  </div>
                  <div *ngIf="forgotPasswordFormControls.emailFormControl.hasError('invalid') && forgotPasswordFormControls.emailFormControl.touched" style="color: red;font-size: 14px;">
                    Email is invalid.
                  </div>
                </div>
                <div  style="margin-top: 20px;">
                  <button class="btn btn-primary left-aligned" (click)="onClickedSendOTP()" style="background-color: #14274e;width: 100px; font-size: 14px; height: 35px;">
                    Send OTP
                  </button>
                </div>
                <div *ngIf="sendOTPClicked && !sendOTPerror" class= "center" style="color: green;font-size: 14px; font-weight: bold;margin-top: 10px;">
                  {{messageToDisplayAfterOtpSent}}
                </div>
                <div *ngIf="sendOTPClicked && sendOTPerror" class= "center" style="color: red;font-size: 14px; font-weight: bold; margin-top: 10px;">
                  {{messageToDisplayAfterOtpSent}}
                </div>

                <div>
                  <form [formGroup]="verifyOTPFormGroup">
                    <div class="row" style="margin-top: 40px;">
                      <div class="col center">
                        <div style="width: 50px;height: 50px;float: left;margin-right: 20px;">
                          <input id="codeBox1" type="text" formControlName="regotp0" maxlength="1" (keyup)="onKeyUpEvent(1, $event)" (focus)="onFocusEvent(1)" style="width: inherit;height: inherit;background-color: #cbcece;border-radius: 12px;border: none;text-align: center;" />
                        </div>
                        <div style="width: 50px;height: 50px;float: left;margin-right: 20px;">
                          <input id="codeBox2" type="text" formControlName="regotp1" maxlength="1" (keyup)="onKeyUpEvent(2, $event)" (focus)="onFocusEvent(2)" style="width: inherit;height: inherit;background-color: #cbcece;border-radius: 12px;border: none;text-align: center;" />
                        </div>
                        <div style="width: 50px;height: 50px;float: left;margin-right: 20px;">
                          <input id="codeBox3" type="text" formControlName="regotp2" maxlength="1" (keyup)="onKeyUpEvent(3, $event)" (focus)="onFocusEvent(3)" style="width: inherit;height: inherit;background-color: #cbcece;border-radius: 12px;border: none;text-align: center;" />
                        </div>
                        <div style="width: 50px;height: 50px;float: left;margin-right: 20px;">
                          <input id="codeBox4" type="text" formControlName="regotp3" maxlength="1" (keyup)="onKeyUpEvent(4, $event)" (focus)="onFocusEvent(4)" style="width: inherit;height: inherit;background-color: #cbcece;border-radius: 12px;border: none;text-align: center;" />
                        </div>
                      </div>
                    </div>
                    <label style="font-size: 14px;height: 15px; font-weight: bold;margin-top: 15px; margin-left:30px;">
                      OTP Validity : 5 Minutes
                    </label>
                    <div class="row" style="margin-left: 30px;margin-top: 20px;">
                      <div class="col">
                        <div *ngIf="showOnClickVerifyError" style="color: red;">{{onClickVerifyError}}</div>
                      </div>
                    </div>
                    <div class="row" style="margin-left: 30px;margin-top: 34px;">
                      <div class="col">
                        <button class="btn btn-primary" type="button" (click)="onClickVerify()" style="background-color: #14274e;width: 100px; font-size: 14px; height: 35px;">
                          Verify
                        </button>
                        <button class="btn btn-primary" type="button" (click)="onClickForgotPasswordCancel()" style="background-color: #FFFF; color: #14274e; width: 100px; height: 35px; font-size: 14px;margin-left: 60px;">
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

              </div>
            </form>
          </div>

          <div *ngIf="showResetPasswordForm">
            <form [formGroup]="resetPasswordFormGroup">
              <div class="form-group auth-form-container">
                <div class="row">
                  <div class="col center" style="margin-top: 20px;">
                    <h1 class="text-center" style="font-size: 30px; padding: 0px;color: #14274e; font-family: 'Nunito-B';">
                      Reset Password
                    </h1>
                  </div>
                </div>
                <div style="margin-top: 20px;">
                  <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="password">
                    PASSWORD
                  </label>
                  <input type="text" style="display:none" />
                  <input type="password" formControlName="passwordFormControl" placeholder="Password"
                         class="form-control auth-input" />
                  <div *ngIf="resetPasswordFormControls.passwordFormControl.hasError('required') && resetPasswordFormControls.passwordFormControl.touched" style="color: red;font-size: 14px;">
                    Password is required
                  </div>
                  <div *ngIf="resetPasswordFormControls.passwordFormControl.hasError('minlength') && resetPasswordFormControls.passwordFormControl.touched" style="color: red;font-size: 14px;">
                    Password must have at least {{minPasswordLength}} characters
                  </div>
                  <div *ngIf="resetPasswordFormControls.passwordFormControl.hasError('pattern') && !resetPasswordFormControls.passwordFormControl.hasError('minlength') && resetPasswordFormControls.passwordFormControl.touched" style="color: red;font-size: 14px;">
                    Password must contain at least 1 or more lowercase letter, uppercase letter, number and special character e.g !@#$%^&*
                  </div>
                </div>
                <div style="margin-top: 20px;">
                  <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="reenter-password">
                    RE-ENTER PASSWORD
                  </label>
                  <input type="text" style="display:none" />
                  <input type="password" formControlName="reenterPasswordFormControl" placeholder="Password"
                         class="form-control auth-input" />
                  <div *ngIf="resetPasswordFormControls.reenterPasswordFormControl.hasError('required') && resetPasswordFormControls.reenterPasswordFormControl.touched" style="color: red;font-size: 14px;">
                    Password is required
                  </div>
                  <div *ngIf="resetPasswordFormControls.reenterPasswordFormControl.hasError('minlength') && resetPasswordFormControls.reenterPasswordFormControl.touched" style="color: red;font-size: 14px;">
                    Password must have at least {{minPasswordLength}} characters
                  </div>
                  <div *ngIf="resetPasswordFormControls.reenterPasswordFormControl.hasError('pattern') && !resetPasswordFormControls.passwordFormControl.hasError('minlength') && resetPasswordFormControls.reenterPasswordFormControl.touched" style="color: red;font-size: 14px;">
                    Password must contain at least 1 or more lowercase letter, uppercase letter, number and special character e.g !@#$%^&*
                  </div>
                  <div *ngIf="resetPasswordFormControls.reenterPasswordFormControl.hasError('confirmedValidator') && !resetPasswordFormControls.reenterPasswordFormControl.hasError('pattern') && !resetPasswordFormControls.passwordFormControl.hasError('minlength') && resetPasswordFormControls.reenterPasswordFormControl.touched" style="color: red;font-size: 14px;">
                    Passwords did not match
                  </div>
                </div>
                <div class="row" style="margin-left: 45px;margin-top: 20px;">
                  <div class="col">
                    <div *ngIf="showOnClickResetPasswordError" style="color: red;">{{onClickResetPasswordError}}</div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col" style="margin-left: 55px;">
                    <button class="btn btn-primary auth-btn" [disabled]="resetPasswordFormGroup.invalid" type="button" (click)="onResetPasswordClicked()" style="background-color: #14274e;">
                      Reset Password
                    </button>
                  </div>
                </div>
                <label style="font-size: 12px;height: 15px;padding-top: 10px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" >
                  Password must have at least {{minPasswordLength}} characters
                </label>
                <label style="font-size: 12px;height: 15px;color: #7c7575;font-weight: bold;" >
                  Password must contain at least 1 or more lowercase letter, uppercase letter, number and special character e.g !@#$%^&*
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- TD Start <nav class="p-5 bg-white shadow">
  <div class="container">
    <div class="flex justify-between items-center">
      <span class="cursor-pointer">
        <a href="#">
          <img src="../assets/img/Logo.svg" alt="Lights" style="width: 40px;height: 40px;">
          Booking Dexter
        </a>
      </span>
      <span class="text-3xml cursor-pointer mx-2 md:hidden block">
        <img src="../assets/img/menu-outline.svg" alt="Lights" style="width: 40px;height: 40px;" >
      </span>
      <ul class="md:flex md:items-center z-[-1] md:z-auto md:static absolute bg-white w-full left-0 md:w-auto md:py-0 py-4 md:pl-0 pl7 top-[-400px]">
        <li class="mx-4" style="height: 40px;">
            <a class="nav-link active" href="#" style="height: 60px;">Home</a>
        </li>
        <li class="mx-4" style="height: 40px;">
            <a class="nav-link" href="#" style="height: 60px;">Features</a>
        </li>
        <li class="mx-4" style="height: 40px;">
            <a class="nav-link" href="#" style="height: 60px;">Pricing</a>
        </li>
        <li class="mx-4" style="height: 40px;">
            <a class="nav-link" href="#" style="height: 60px;">Book Now</a>
        </li>
        <li class="mx-4" style="height: 40px;">
            <a class="nav-link" href="#" routerLink="/all-products" style="height: 60px;">Products</a>
        </li>
        <li *ngIf="!isLoggedIn()" class="mx-4" style="height: 40px;">
            <a class="nav-link" (click)="onClickLogin()" style="height: 60px; color: #14274E; font-size: 16px;">Login</a>
        </li>
        <li *ngIf="isLoggedIn()" class="mx-4" style="height: 40px;">
            <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height: 60px; color: #14274E; font-size: 16px;">{{getLoginDisplayText()}}</a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <a class="dropdown-item" (click)="clickedLogout()">Logout</a>
              </div>
        </li>
      </ul>
    </div>
  </div>
</nav> TD End-->



<!--
    data-toggle="modal" data-target="#myModal"
    <div class="modal" id="myModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <div class="modal-body">
          Modal body..
        </div>
      </div>
    </div>
  </div>
   -->
